const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: 'Entrée min et max invalide.',
    invalid_options: 'Options de champ invalides.',
    invalid_regex_format: 'Format de regex invalide.',
    invalid_address_parts: "Parties d'adresse invalides.",
    invalid_fullname_parts: 'Parties de nom complet invalides.',
    name_exists: 'Un champ existe déjà avec ce nom.',
    conflicted_sie_order: "Valeur d'ordre de champ en conflit pour l'expérience de connexion.",
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
